import { InibuildsA300Seo } from "../../../content/templateMarketing/inibuilds-a300-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import inibuildsA300Logo from "../../images/templates/inibuilds-A300.png";

export const inibuildsA300Template: AircraftAddonTemplate = {
  type: "aircraft",
  id: "inibuilds-a300-600",
  title: "Inibuilds A300",
  platforms: ["msfs", "xplane"],
  image: inibuildsA300Logo,
  infoMarketingBlurb: InibuildsA300Seo,
  content: [
    {
      title: "Before Start",
      roles: ["cockpitPreparation", "beforeFlightStart", "beforePushback", "beforeEngineStart"],
      content: [
        {
          item: "Cockpit Preparation",
          setting: "Completed",
        },
        {
          item: "Fuel Quantity",
          setting: "____ kg/lb",
        },
        {
          item: "Takeoff Data",
          setting: "Set",
        },
        {
          item: "Landing Elevation",
          setting: " ____ Set",
        },
        {
          item: "Altimeters",
          setting: "____ Set",
        },
        {
          item: "Brake / Anti-skid",
          setting: "Normal / On",
        },
        {
          item: "Windows / Doors",
          setting: "Closed",
        },
        {
          header: "Before Pushback",
        },
        {
          item: "Beacon",
          setting: "On",
        },
        {
          item: "Parking Brake",
          setting: "As Required",
        },
      ],
    },
    {
      title: "After Start",
      roles: ["afterEngineStart"],
      content: [
        {
          item: "Pitch Trim",
          setting: "Set",
        },
        {
          item: "Rudder Trim",
          setting: "Zero",
        },
        {
          item: "Spoilers",
          setting: "Armed",
        },
        {
          item: "Slats/Flaps",
          setting: "___ / ___",
        },
        {
          item: "ECAM Status",
          setting: "Checked",
        },
        {
          item: "Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Hand Signal",
          setting: "Received",
        },
      ],
    },
    {
      title: "Before Takeoff",
      roles: ["beforeTakeoff", "beforeTaxi", "taxi", "takeoff"],
      content: [
        {
          header: "Taxi",
        },
        {
          item: "Flight Controls",
          setting: "Checked",
        },
        {
          item: "Flight Instruments",
          setting: "Checked",
        },
        {
          item: "Briefing",
          setting: "Confirmed",
        },
        {
          item: "Takeoff Data",
          setting: "V1 _, VR _, V2 _, Flx Temp _",
        },
        {
          item: "Slats / Flaps",
          setting: "__ / __",
        },
        {
          item: "Takeoff Config",
          setting: "Normal for Takeoff",
        },
        {
          header: "Lineup",
        },
        {
          item: "Transponder",
          setting: "Set",
        },
        {
          item: "TCAS",
          setting: "TA/RA",
        },
        {
          item: "Autobrake",
          setting: "Max",
        },
        {
          item: "Ignition",
          setting: "As Required",
        },
      ],
    },
    {
      title: "After Takeoff / Climb",
      roles: ["climbOut"],
      content: [
        {
          item: "Slats / Flaps",
          setting: "Retracted",
        },
        {
          item: "Landing Gear",
          setting: "Up / Neutral",
        },
        {
          item: "Packs",
          setting: "On",
        },
        {
          item: "Altimeters",
          setting: "___ Set",
        },
      ],
    },
    {
      title: "Approach",
      roles: ["approach", "beforeDescent"],
      content: [
        {
          item: "Signs",
          setting: "Set",
        },
        {
          item: "Briefing",
          setting: "Confirmed",
        },
        {
          item: "ECAM Status",
          setting: "Checked",
        },
        {
          item: "Altimeters",
          setting: "___ Set",
        },
        {
          item: "Minimums",
          setting: "___ Set",
        },
        {
          item: "Ignition",
          setting: "Cont Relight",
        },
        {
          item: "Landing Elevation",
          setting: "___ Set",
        },
      ],
    },
    {
      title: "Landing",
      roles: ["landing"],
      content: [
        {
          item: "Landing Gear",
          setting: "Down",
        },
        {
          item: "Autobrake",
          setting: "As Required",
        },
        {
          item: "Anti Skid",
          setting: "Checked",
        },
        {
          item: "Slats / Flaps",
          setting: "__ /__",
        },
        {
          item: "Spoilers",
          setting: "Armed",
        },
      ],
    },
    {
      title: "After Landing",
      roles: ["afterLanding"],
      content: [
        {
          item: "Slats / Flaps",
          setting: "Retrated",
        },
        {
          item: "Transponder",
          setting: "As Required",
        },
        {
          item: "Weather Radar",
          setting: "Off",
        },
        {
          item: "Spoilers",
          setting: "Disarmed",
        },
        {
          item: "APU",
          setting: "Started",
        },
      ],
    },
    {
      title: "Parking",
      roles: ["parking", "shutdown"],
      content: [
        {
          item: "APU Bleed",
          setting: "As Required",
        },
        {
          item: "Engines",
          setting: "Off",
        },
        {
          item: "AP (Diff Press)",
          setting: "Check Zero",
        },
        {
          item: "Lights / Signs",
          setting: "As Required",
        },
        {
          item: "Fuel Pumps",
          setting: "Off",
        },
        {
          item: "Window / Probe Heat",
          setting: "OFF",
        },
        {
          item: "Parking Brake / Chocks",
          setting: "As Required",
        },
      ],
    },
    {
      title: "Securing Aircraft",
      roles: ["securing"],
      content: [
        {
          item: "Nav Systems",
          setting: "Off",
        },
        {
          item: "Oxygen",
          setting: "Off",
        },
        {
          item: "APU Bleed",
          setting: "Off",
        },
        {
          item: "Emergency Exit Lights",
          setting: "Disarmed",
        },
        {
          item: "APU and Battery",
          setting: "Off",
        },
      ],
    },
  ],
};
